module.exports = __webpack_public_path__ + "img/gmail.9b46a308.svg";